import React, { useEffect, useState, Fragment } from "react";
import { Typography, Box, makeStyles } from "@material-ui/core";

//images
import SUFFISANTE from "../../../../../images/pictos-ok/SUFFISANTE.svg";
import CADEBORDE from "../../../../../images/pictos-ok/CADEBORDE.svg";
import CLAIRES from "../../../../../images/pictos-ok/CLAIRE.svg";
import COMPLEXES from "../../../../../images/pictos-ok/COMPLEXES.svg";
import RESPECTE from "../../../../../images/pictos-ok/RESPECTÉ.svg";
import PAS_RESPECTE from "../../../../../images/pictos-ok/PAS RESPECTÉ.svg";

const useStyles = makeStyles((theme) => ({
  switchLabel: {
    marginTop: 20,
    textAlign: "center",
  },
  boxSwitch: {
    display: "flex",
    justifyContent: "space-around",
  },
  labelRangeLeft: {
    width: "100%",
    textAlign: "left",
    marginLeft: 20,
  },
  labelRangeRight: {
    width: "100%",
    textAlign: "right",
    marginRight: 20,
  },
}));

const Step2 = (props) => {
  const classes = useStyles();
  // eslint-disable-next-line no-unused-vars
  const [value, setValue] = useState({
    capacite: 50,
    presence_tri: 50,
    informations: 50,
  });

  useEffect(() => {
    // Quand le composant se charge, autorise à passer à la suite
    props.setAuthorization(true);
    // Insérer les réponses par défaut des range dans la réponse
    for (let element in value) {
      props.result[element] = value[element];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRangeChange = (event) => {
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult[event.target.name] = event.target.valueAsNumber;
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
  };

  return (
    <Fragment>
      <Typography variant="body1" component="legend" style={{ marginLeft: 20 }}>
        J'indique la présence ou le manque, la propreté ...
      </Typography>
      {/* Première ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        La capacité des poubelles
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography variant="body1" className={classes.labelRangeLeft}>
          <img src={SUFFISANTE} alt="Suffisante" />
          Suffisante
        </Typography>
        <input
          name="capacite"
          type="range"
          min="0"
          max="100"
          onChange={handleRangeChange}
        />
        <Typography variant="body1" className={classes.labelRangeRight}>
          <img src={CADEBORDE} alt="ça deborde" />
          Ca déborde
        </Typography>
      </Box>
      {/* Deuxième ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        Les informations
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography variant="body1" className={classes.labelRangeLeft}>
          <img src={CLAIRES} alt="Claires" />
          Claires
        </Typography>
        <input
          name="informations"
          type="range"
          min="0"
          max="100"
          onChange={handleRangeChange}
        />
        <Typography variant="body1" className={classes.labelRangeRight}>
          <img src={COMPLEXES} alt="Complexes" />
          Complexes
        </Typography>
      </Box>
      {/* Troisième ligne */}
      <Typography variant="body1" className={classes.switchLabel}>
        Le tri
      </Typography>
      <Box className={classes.boxSwitch}>
        <Typography variant="body1" className={classes.labelRangeLeft}>
          <img src={RESPECTE} alt="Respecté" />
          Respecté
        </Typography>
        <input
          name="presence_tri"
          type="range"
          min="0"
          max="100"
          onChange={handleRangeChange}
        />
        <Typography variant="body1" className={classes.labelRangeRight}>
          <img src={RESPECTE} alt="Respecté" />
          Pas respecté
        </Typography>
      </Box>
    </Fragment>
  );
};

export default Step2;
